import Env from 'Env';
import { cashSupportEmail } from 'utilities/cash-utilities';

const CUSTOMER_SERVICE_PHONE = Env.getCustomerServicePhone();
const isAdmin = Env.isAdminPortal();

/**
 * Types of Alert or Toast Notification Messages
 * @enum
 */
const Alert = {
  SESSION_EXPIRED: 'Session expired. Please refresh the page or the page will auto-refresh in 10 seconds.',
  NO_ACCESS: 'Your access level has changed. Please refresh the page.',

  // CARDS PAGE ALERTS
  EDIT_MULTIPLE_CARD_LOADING: 'Processing edit cards request...',
  EDIT_MULTIPLE_CARD_ERROR: `Sorry we've run into a technical issue processing your cards, please contact our customer service team immediately on ${CUSTOMER_SERVICE_PHONE} so we can get your card on the way.`,

  EDIT_CARD_LOADING: 'Processing edit card request...',
  EDIT_CARD_ERROR: `Sorry we've run into a technical issue processing your card, please contact our customer service team immediately on ${CUSTOMER_SERVICE_PHONE} so we can get your card on the way.`,
  EDIT_CARD_SUCCESS: 'Card details successfully updated.',

  CREATE_CARD_LOADING: 'Processing create card request...',
  CREATE_CARD_ERROR: `Sorry we've run into a technical issue processing your card, please contact our customer service team immediately on ${CUSTOMER_SERVICE_PHONE} so we can get your card on the way.`,

  RESET_PIN_LOADING: 'Processing reset PIN request...',
  RESET_PIN_ERROR: `Sorry we've run into a technical issue resetting PIN on your card, please contact our customer service team immediately on ${CUSTOMER_SERVICE_PHONE} so we can get your card on the way.`,
  RESET_PIN_SUCCESS: 'PIN Reset Request successful.',

  UPDATE_PIN_LOADING: 'Processing update PIN request...',
  UPDATE_PIN_ERROR: `Sorry we've run into a technical issue setting PIN on your card, please contact our customer service team immediately on ${CUSTOMER_SERVICE_PHONE} so we can get your card on the way.`,
  UPDATE_PIN_SUCCESS: 'PIN successfully updated.',

  ACTIVATE_CARD_LOADING: 'Processing activate card request...',
  ACTIVATE_CARD_SUCCESS: 'Card successfully activated.',
  ACTIVATE_CARD_ERROR: `Sorry we've run into a technical issue activating your card, please contact our customer service team immediately on ${CUSTOMER_SERVICE_PHONE} so we can get your card on the way.`,

  ACTIVATE_MULTIPLE_LOADING: 'Processing activate cards request...',
  ACTIVATE_MULTIPLE_SUCCESS: 'Activation succeeded.',
  ACTIVATE_MULTIPLE_PARTIAL: 'Activation succeeded with failures',
  ACTIVATE_MULTIPLE_ERROR: 'Activation failed.',

  TRANSFER_CARD_LOADING: 'Processing transfer card request...',
  TRANSFER_CARD_ERROR: `Sorry we've run into a technical issue transferring your card, please contact our customer service team immediately on ${CUSTOMER_SERVICE_PHONE} so we can get your card on the way.`,
  TRANSFER_CARD_SUCCESS: 'Card has been transferred successfully.',

  TRANSFER_MULTIPLE_CARD_LOADING: 'Processing transfer cards request...',
  TRANSFER_MULTIPLE_CARD_ERROR: `Sorry we've run into a technical issue transferring your card, please contact our customer service team immediately on ${CUSTOMER_SERVICE_PHONE} so we can get your card on the way.`,
  TRANSFER_MULTIPLE_CARD_SUCCESS: 'Cards have been transfered successfully.',

  EDIT_TRANSFER_CARD_LOADING: 'Processing edit transfer request...',
  EDIT_TRANSFER_CARD_ERROR: `Sorry we've run into a technical issue editing your card transfers, please contact our customer service team immediately on ${CUSTOMER_SERVICE_PHONE} so we can get your card on the way.`,
  EDIT_TRANSFER_CARD_SUCCESS: 'Card transfers have been updated.',

  DELETE_TRANSFER_CARD_LOADING: 'Processing delete transfer request...',
  DELETE_TRANSFER_CARD_ERROR: `Sorry we've run into a technical issue deleting your card transfers, please contact our customer service team immediately on ${CUSTOMER_SERVICE_PHONE} so we can get your card on the way.`,
  DELETE_TRANSFER_CARD_SUCCESS: 'Card transfers have been deleted.',

  UPDATE_CARD_STATUS_LOADING: 'Processing card status update request...',
  UPDATE_CARD_STATUS_SUCCESS: 'Card status has been updated.',
  UPDATE_CARD_STATUS_ERROR: `Sorry we've run into a technical issue updating your card status, please contact our customer service team immediately on ${CUSTOMER_SERVICE_PHONE} so we can get your card on the way.`,

  UPDATE_MULTIPLE_CARD_STATUS_LOADING: 'Processing cards status update request...',
  UPDATE_MULTIPLE_CARD_STATUS_SUCCESS: 'Card statuses have been updated.',
  UPDATE_MULTIPLE_CARD_STATUS_ERROR: `Sorry we've run into a technical issue updating your card statuses, please contact our customer service team immediately on ${CUSTOMER_SERVICE_PHONE} so we can get your card on the way.`,
  // Deprecated: AmpCharge cards can now be edited through the portal
  UPDATE_MULTIPLE_CARD_STATUS_ERROR_AMPCHARGE: `Sorry we've run into a technical issue updating your card statuses, please contact our customer service team immediately on ${CUSTOMER_SERVICE_PHONE} so we can get your card on the way.`,

  GET_CARD_DETAIL_ERROR: 'Failed to get card details. Please try again later.',

  EDIT_CARD_OPTIONS_LOADING: 'Processing edit card options request...',
  EDIT_CARD_OPTIONS_SUCCESS: 'Card usage options have been updated.',
  EDIT_CARD_OPTIONS_ERROR: 'Failed to edit card options. Please try again later.',
  // Deprecated: AmpCharge cards can now be edited through the portal
  EDIT_CARD_OPTIONS_ERROR_AMPCHARGE: 'Failed to edit card options. Please try again later.',

  FETCH_ACC_DEFAULTS_ERROR: 'Error occurred while retrieving data. Please try again later.',

  DOWNLOAD_CARDS_LOADING: 'Processing download cards list request...',
  DOWNLOAD_CARDS_SUCCESS: 'Cards list has been downloaded.',
  DOWNLOAD_CARDS_ERROR: 'Failed to download cards list. Please try again later.',

  DOWNLOAD_TRANSACTIONS_LOADING: 'Processing download transactions list request...',
  DOWNLOAD_TRANSACTIONS_SUCCESS: 'Transactions list has been downloaded.',
  DOWNLOAD_TRANSACTIONS_ERROR: 'Failed to download transactions list. Please try again later.',

  DOWNLOAD_TRANSFERS_LOADING: 'Processing download pending transfers list request...',
  DOWNLOAD_TRANSFERS_SUCCESS: 'Pending transfers list has been downloaded.',
  DOWNLOAD_TRANSFERS_ERROR: 'Failed to download pending transfers list. Please try again later.',

  CUSTOMER_SUPPORT_ERROR: 'Please contact Customer Support.',

  GLOBAL_SEARCH_NOT_FOUND:
    'We were unable to find a matching card or registration, please check the search term and try again.',
  GLOBAL_SEARCH_ERROR: 'Please try again or contact support.',

  // USERS PAGE ALERTS
  UPDATE_USER_LOADING: 'Processing user update request...',
  UPDATE_USER_ERROR: 'Failed to update user details. Please try again later.',
  UPDATE_USER_SUCCESS: 'User details have been updated.',

  FETCH_USER_ERROR: 'Failed to fetch user details. Please try again later.',

  REMOVE_ACCOUNT_ACCESS_LOADING: 'Processing remove account access request...',
  REMOVE_ACCOUNT_ACCESS_ERROR: 'Failed to remove account access. Please try again later.',
  REMOVE_ACCOUNT_ACCESS_SUCCESS: 'Account access has been removed.',

  ASSIGN_ACCOUNTS_LOADING: 'Processing assign account request...',
  ASSIGN_ACCOUNTS_SUCCESS: 'Account has been assigned.',
  ASSIGN_ACCOUNTS_ERROR: 'Failed to assign account. Please try again later.',

  DEACTIVATE_ACCESS_LOADING: 'Processing deactivate request...',
  DEACTIVATE_ACCESS_ERROR: 'User deactivate failed. Please try again later.',
  DEACTIVATE_ACCESS_SUCCESS: 'User has been deactivated.',

  DOWNLOAD_USERS_LOADING: 'Processing download users list request...',
  DOWNLOAD_USERS_SUCCESS: 'Users list has been downloaded.',
  DOWNLOAD_USERS_ERROR: 'Failed to download users. Please try again later.',

  ADD_USER_LOADING: 'Processing add user request...',
  ADD_USER_SUCCESS: 'New user added successfully!',
  ADD_USER_ERROR: 'Failed to add user.',

  EMAIL_VALID: 'Email is valid.',
  EMAIL_INVALID: 'Failed to validate email. Please try again later.',
  EMAIL_REGISTERED: 'Email is already registered. Please edit the user to assign accounts.',

  // ACCOUNT PAGE ALERTS
  UPDATE_ADDRESS_LOADING: 'Processing address update request...',
  UPDATE_ADDRESS_SUCCESS: 'Address updated successfully.',
  UPDATE_ADDRESS_ERROR: 'Failed to update address. Please try again later.',

  MAKE_PAYMENT_LOADING: 'Processing payment request...',
  MAKE_PAYMENT_SUCCESS: 'Payment has been processed.',
  MAKE_PAYMENT_ERROR: 'Failed to process payment. Please try again later.',

  ADD_FAV_LOADING: 'Processing create card option favourite request...',
  ADD_FAV_SUCCESS: 'Card option favourite created successfully.',
  ADD_FAV_ERROR: 'Failed to create card option favourite. Please try again later.',

  EDIT_FAV_LOADING: 'Processing edit card option favourite request...',
  EDIT_FAV_SUCCESS: 'Card option favourite updated successfully.',
  EDIT_FAV_ERROR: 'Failed to update card option favourite. Please try again later.',

  MYOB_DISCONNECT_LOADING: 'Processing MYOB disconnect request...',
  MYOB_DISCONNECT_SUCCESS: 'MYOB disconnected successfully.',
  MYOB_DISCONNECT_ERROR: 'Failed to disconnect MYOB. Please try again later.',

  XERO_DISCONNECT_LOADING: 'Processing XERO disconnect request...',
  XERO_DISCONNECT_SUCCESS: 'XERO disconnected successfully.',
  XERO_DISCONNECT_ERROR: 'Failed to disconnect XERO. Please try again later.',

  DOWNLOAD_ACCOUNTS_LOADING: 'Processing download accounts list request...',
  DOWNLOAD_ACCOUNTS_SUCCESS: 'Accounts list has been downloaded.',
  DOWNLOAD_ACCOUNTS_ERROR: 'Failed to download accounts list. Please try again later.',

  XERO_CONNECT_ERROR:
    'Something went wrong linking your Xero account, please close this window and try again or contact support.',
  XERO_CONNECT_LOADED: 'Xero integration completed. You may now close this window.',
  XERO_CONNECT_LOADING: 'Processing connect Xero request...',

  EDR_CONNECT_ERROR:
    'Something went wrong linking your Everyday Rewards account, please close this window and try again or contact support.',
  EDR_CONNECT_LOADED: 'Everyday Rewards linking completed. You may now close this window.',
  EDR_CONNECT_LOADING: 'Processing connect Everyday Rewards request...',

  // REPORTS
  CREATE_REPORT_LOADING: 'Processing create report request...',
  CREATE_REPORT_SUCCESS: 'Report has been created successfully.',
  CREATE_ADHOC_REPORT_SUCCESS:
    'Report request received.|Your report is being generated and will be emailed to your nominated address(es) once ready. Delivery time may vary depending on the volume of data being processed.',
  CREATE_REPORT_ERROR: 'Something went wrong creating the report, please try again or contact support.',

  EDIT_REPORT_LOADING: 'Processing edit report schedule request...',
  EDIT_REPORT_SUCCESS: 'Report schedule has been edited successfully.',
  EDIT_REPORT_ERROR: 'Something went wrong updating the report, please try again or contact support.',

  DELETE_REPORT_LOADING: 'Processing delete report schedule request...',
  DELETE_REPORT_SUCCESS: 'Report schedule has been deleted.',
  DELETE_REPORT_ERROR: 'Something went wrong deleting the report schedule, please try again or contact support.',

  ENABLE_REPORT_LOADING: 'Processing enable report schedule request...',
  ENABLE_REPORT_SUCCESS: 'Report schedule has been enabled successfully.',
  ENABLE_REPORT_ERROR: 'Something went wrong enabling the report schedule, please try again or contact support.',

  DISABLE_REPORT_LOADING: 'Processing disable report schedule request...',
  DISABLE_REPORT_SUCCESS: 'Report schedule has been disabled successfully.',
  DISABLE_REPORT_ERROR: 'Something went wrong disabling the report schedule, please try again or contact support.',

  DOWNLOAD_REPORT_LOADING: 'Processing download report request...',
  DOWNLOAD_REPORT_SUCCESS: 'Report has been download successfully.',
  DOWNLOAD_REPORT_ERROR: 'Something went wrong downloading the report, please try again or contact support.',

  DOWNLOAD_INVOICES_LOADING: 'Processing download invoice request...',
  DOWNLOAD_INVOICES_SUCCESS: 'Invoice has been downloaded.',
  DOWNLOAD_INVOICES_ERROR: 'Failed to download invoice. Please try again later.',

  // SCHEDULED MAINTENANCE
  GET_SCHEDULE_ERROR: 'Failed to fetch schedule details. Please try again later.',
  ADD_SCHEDULE_LOADING: 'Processing add scheduled maintenance request...',
  ADD_SCHEDULE_SUCCESS: 'Scheduled maintenance has been added.',
  ADD_SCHEDULE_ERROR: 'Failed to add scheduled maintenance. Please try again later.',

  EDIT_SCHEDULE_REQUEST: 'Processing edit scheduled maintenance request...',
  EDIT_SCHEDULE_SUCCESS: 'Scheduled maintenance has been updated.',
  EDIT_SCHEDULE_ERROR: 'Failed to delete scheduled maintenance. Please try again later.',

  DELETE_SCHEDULE_REQUEST: 'Processing delete scheduled maintenance request...',
  DELETE_SCHEDULE_SUCCESS: 'Schedule maintenance deleted successfully.',
  DELETE_SCHEDULE_ERROR: 'Failed to delete scheduled maintenance. Please try again later.',

  // CARD MAINTENANCE
  ADD_PLASTIC_TYPE_LOADING: 'Processing add plastic type request...',
  ADD_PLASTIC_TYPE_SUCCESS: 'Plastic type created successfully.',
  ADD_PLASTIC_TYPE_ERROR: 'Failed to add plastic type. Please try again later.',

  EDIT_PLASTIC_TYPE_LOADING: 'Processing update plastic type request...',
  EDIT_PLASTIC_TYPE_SUCCESS: 'Plastic type updated successfully.',
  EDIT_PLASTIC_TYPE_ERROR: 'Failed to update plastic type. Please try again later.',

  // CASH
  ACTIVATE_ALL_SUCCESS: 'Your activation request has been submitted. Please check notification icon for updates.',
  ACTIVATE_ALL_ERROR: `Sorry we've run into a technical issue activating your cards, please contact our customer service team immediately on ${CUSTOMER_SERVICE_PHONE} so we can get your cards on the way.`,
  ACTIVATE_ALL_LOADING: 'Processing activate all cards request...',

  DELIVERY_INVALID_EMAIL:
    'Email ID in Billing address is invalid. Please enter a valid email address by selecting other options.',
  DELIVERY_OPTIONS_INFO: 'Please add recipient(s) for all cards before continuing.',

  CREATE_CASH_ERROR: `Something went wrong placing this order, please try again ${isAdmin ? '' : 'or contact ' + cashSupportEmail()}`,

  GET_CASH_DEFAULTS_ERROR: `Something went wrong with your request, please refresh and try again ${isAdmin ? '' : 'or contact ' + cashSupportEmail()}`,
};

export default Alert;
